// Generated by tools/build-agent-plugins.mjs; do not edit.
export const AGENT_INTEGRATIONS = {
    "environment": "uat",
    "version": "0.1.6",
    "apiOrigin": "https://api-uat.nimblybase.com",
    "hosts": [
        {
            "id": "claude",
            "name": "Claude Code",
            "format": "claude",
            "documentation": "https://code.claude.com/docs/en/plugins-reference",
            "surface": "Claude Code; Desktop is a separate connector route",
            "packageState": "prepared",
            "installationVerified": false,
            "oauthVerified": false,
            "appVerified": false,
            "published": false
        },
        {
            "id": "codex",
            "name": "Codex",
            "format": "portable",
            "documentation": "https://developers.openai.com/plugins/build/plugins",
            "surface": "Desktop/CLI installation and fresh OAuth acceptance pending",
            "packageState": "prepared",
            "installationVerified": false,
            "oauthVerified": false,
            "appVerified": false,
            "published": false
        },
        {
            "id": "cursor",
            "name": "Cursor",
            "format": "portable",
            "documentation": "https://cursor.com/docs/plugins",
            "surface": "Local imports may require team-admin permission",
            "packageState": "prepared",
            "installationVerified": false,
            "oauthVerified": false,
            "appVerified": false,
            "published": false
        },
        {
            "id": "openclaw",
            "name": "OpenClaw",
            "format": "portable",
            "documentation": "https://docs.openclaw.ai/plugins/bundles",
            "surface": "Isolated personal agent only until per-requester authorization and hosted builds are proven",
            "packageState": "prepared",
            "installationVerified": false,
            "oauthVerified": false,
            "appVerified": false,
            "published": false
        },
        {
            "id": "grokbot",
            "name": "Grok Bot",
            "format": "candidate",
            "documentation": "https://x.ai/bot/marketplace",
            "surface": "Personal desktop manual HTTPS MCP and cloud-built private app tested; portable package import and public listing remain unverified",
            "manualMcp": {
                "hostVersion": "0.68.1",
                "setupVerified": true,
                "appVerified": true,
                "freshOAuthVerified": false,
                "lifecycleVerified": false
            },
            "packageState": "candidate",
            "installationVerified": false,
            "oauthVerified": false,
            "appVerified": false,
            "published": false
        },
        {
            "id": "hermes",
            "name": "Hermes Agent",
            "format": "portable",
            "documentation": "https://hermes-agent.nousresearch.com/docs/developer-guide/plugins",
            "surface": "Explicit enablement and remote OAuth/runtime acceptance pending",
            "packageState": "prepared",
            "installationVerified": false,
            "oauthVerified": false,
            "appVerified": false,
            "published": false
        },
        {
            "id": "qoder",
            "name": "Qoder",
            "format": "qoder",
            "documentation": "https://docs.qoder.com/cli/plugins-reference",
            "surface": "CLI and IDE installation/OAuth must be tested independently",
            "packageState": "prepared",
            "installationVerified": false,
            "oauthVerified": false,
            "appVerified": false,
            "published": false
        }
    ]
};
//# sourceMappingURL=agent-integrations.js.map